import {TSBeitragStatus} from './enums/TSBeitragStatus';

export default class TSBeitragPreFilterDTO {
    status: TSBeitragStatus | undefined;

    constructor(status: TSBeitragStatus|undefined) {
        this.status = status;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/TSBeitragPreFilterDTO.ts